const NEWSLETTER_URL = "https://elianajourney.substack.com/";

const NewsletterSection: React.FC = () => {
  return (
    <section className="bg-gray-900 text-white py-16 px-4 border-t border-cyan-400/20">
      <div className="max-w-3xl mx-auto text-center">
        <p className="text-sm text-cyan-400 font-semibold mb-3">Stay in the loop</p>
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Want more guides like this?
        </h2>

        <p className="text-lg text-gray-300 mb-8 leading-relaxed">
          I share indie hacking stories, SaaS builds, and practical tutorials on my Substack. No spam — just real builder content.
        </p>

        <a
          href={NEWSLETTER_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-cyan-400 hover:bg-cyan-300 text-black hover:text-black font-bold py-4 px-12 rounded-lg text-xl transition-all transform hover:scale-105 shadow-lg shadow-cyan-400/50"
        >
          Subscribe on Substack
        </a>

        <p className="text-sm text-gray-400 mt-4">
          Free newsletter · Unsubscribe anytime
        </p>
      </div>
    </section>
  );
};

export default NewsletterSection;
